<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">特殊专业关键词</div>
    </div>
    <div class="nav2">
      <div class="myForm">
        <!-- 显示重复关键词 -->
        <div v-if="duplicateKeywords.length > 0" class="duplicate-warning">
          <el-alert
            title="发现重复的关键词："
            type="warning"
            :closable="false"
            show-icon>
            <div class="duplicate-keywords">
              <el-tag
                v-for="(keyword, index) in duplicateKeywords"
                :key="index"
                type="warning"
                style="margin-right: 8px; margin-bottom: 8px">
                {{ keyword }}
              </el-tag>
            </div>
          </el-alert>
        </div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <el-col :span="24">
              <div class="table-container">
                <table class="custom-table">
                  <thead>
                    <tr>
                      <th>特殊专业关键词</th>
                      <th>不允许前缀</th>
                      <th>允许后缀</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in tableData" :key="index">
                      <td>
                        <el-input v-model="item.words" placeholder="请输入特殊专业关键词，多个关键词用英文逗号分隔"></el-input>
                      </td>
                      <td>
                        <el-input v-model="item.denied_preffix" placeholder="请输入不允许的前缀，多个前缀用英文逗号分隔"></el-input>
                      </td>
                      <td>
                        <el-input v-model="item.allow_suffix" placeholder="请输入允许的后缀，多个后缀用英文逗号分隔"></el-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button style="margin-top:10px" icon="el-icon-s-promotion" size="small" type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        zy_special: []
      },
      tableData: []
    };
  },
  computed: {
    duplicateKeywords() {
      // 存储所有行的关键词
      const rowKeywords = this.tableData.map(row => {
        if (!row.words) return new Set();
        return new Set(row.words.split(/[,，]/).map(k => k.trim()).filter(k => k));
      });

      // 存储所有重复的关键词
      const duplicates = new Set();
      
      // 比较每一行与其他行的关键词
      for (let i = 0; i < rowKeywords.length; i++) {
        for (let j = i + 1; j < rowKeywords.length; j++) {
          // 找出两行之间的重复词
          const intersection = new Set(
            [...rowKeywords[i]].filter(keyword => rowKeywords[j].has(keyword))
          );
          
          // 将重复词添加到结果中
          intersection.forEach(keyword => duplicates.add(keyword));
        }
      }
      
      return Array.from(duplicates);
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await this.$api.crudselectonebyid({
        table: 'systems',
        id: 1,
        columns: 'zy_special'
      });
      if (res.data && res.data.data && res.data.data.zy_special) {
        try {
          this.ruleForm.zy_special = JSON.parse(res.data.data.zy_special);
          this.tableData = [...this.ruleForm.zy_special];
          // 确保至少有20行
          while (this.tableData.length < 20) {
            this.tableData.push({
              words: '',
              denied_preffix: '',
              allow_suffix: ''
            });
          }
        } catch (e) {
          console.error('JSON parse error:', e);
          this.tableData = Array(20).fill().map(() => ({
            words: '',
            denied_preffix: '',
            allow_suffix: ''
          }));
        }
      } else {
        // 如果没有数据，创建20行空数据
        this.tableData = Array(20).fill().map(() => ({
          words: '',
          denied_preffix: '',
          allow_suffix: ''
        }));
      }
    },
    // 提交
    async submitForm() {
      // 过滤掉空行
      const validData = this.tableData.filter(row => 
        row.words || row.denied_preffix || row.allow_suffix
      );
      
      const res = await this.$api.crudupdatebyid({
        table: 'systems',
        id: 1,
        values: {
          zy_special: JSON.stringify(validData)
        }
      });
      
      if (res.data && res.data.result == 1) {
        this.$message({
          message: res.data.msg || '保存成功',
          type: "success"
        });
        this.getData();
      } else {
        this.$message.error(res.data ? res.data.msg : '保存失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.index {}

.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;

  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
    padding-bottom: 20px;
  }
}

.nav2 {
  margin: 18px 0;
  background: #fff;
  border-radius: 6px;
  padding: 24px;

  .myForm {
    ::v-deep .el-form-item__label {
      font-size: 12px;
    }

    ::v-deep .el-form-item {
      margin-right: 30px;
      margin-bottom: 20px;
    }
  }
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;

  th, td {
    border: 1px solid #EBEEF5;
    padding: 12px;
    text-align: left;
  }

  th {
    background-color: #F5F7FA;
    color: #606266;
    font-weight: 500;
  }

  td {
    .el-input {
      width: 100%;
    }
  }
}

.duplicate-warning {
  margin-bottom: 20px;
  
  .duplicate-keywords {
    margin-top: 10px;
  }
}
</style> 